import * as React from 'react';
import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Service from '../Networking/NetworkingUtils';
import { getCookie } from '../Utils/CookieHelper';
import { useSnackbar } from 'notistack';
import { Box, List, Paper, Typography } from '@mui/material';


function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

const token = getCookie("bb_metaverse_token");

function ProjectAccessList(props) {

  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState(props.left);
  const [right, setRight] = React.useState(props.right);
  const { enqueueSnackbar } = useSnackbar();
  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);
  const initialRender = React.useRef(true);
  // Track previous left/right for link/delink detection
  const prevLeft = React.useRef(left);
  const prevRight = React.useRef(right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const postAccess = (action, access) => {
    let obj = {}

    for (let index = 0; index < left.length; index++) {
      obj[left[index]] = false
    }
    for (let index = 0; index < right.length; index++) {
      obj[right[index]] = true
    }
    let data = {}
    let api = ''
    if(props.groupedAccess){
      api="/api/projects/level/access/edit_user_group_access/"
      data = {
        project: props.project.id,
        user: props.access.user,
        group_access_data: obj,
        id: props.access.id
      }
    }else{
      api="/api/projects/level/access/edit_user_individual_access/"
      data = {
        project: props.project.id,
        user: props.access.user,
        direct_access_data: obj,
        id: props.access.id,
      }
    }
    Service.post(api, {
      headers: {
        Authorization: "Token " + token,
      },
      data: data
    })
      .then(res => {
        props.callBack()
      })
      .catch(error => {
        enqueueSnackbar('Something went wrong!', {
          variant: 'error'
        });
        console.log(error)
      });
  }

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };


  const customList = (items) => (
    <Paper sx={{ width: 300, height: 230, overflow: 'auto' }}>
      <List dense component="div" role="list">
        {items.map((value) => {
          const labelId = `transfer-list-item-${value}-label`;

          return (
            <ListItem
              key={value}
              role="listitem"
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  // sx={{ color: dark ? 'white' : '' }}
                  inputProps={{
                    'aria-labelledby': labelId,
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={props.groupedAccess ? value : props.accessObj[value]} />
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );

  React.useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      // Detect link (moved to right) and delink (removed from right)
      const linked = right.filter(item => !prevRight.current.includes(item));
      const delinked = prevRight.current.filter(item => !right.includes(item));
      if (linked.length > 0) {
        console.log('Linked:', linked);
        let id = [];
        for (let index = 0; index < linked.length; index++) {
          const element = linked[index];
          id.push(element.id)
        }
        postAccess('link', id);

      }
      if (delinked.length > 0) {
        console.log('Delinked:', delinked);
        let delinkedId = [];
        for (let index = 0; index < delinked.length; index++) {
          const element = delinked[index];
          delinkedId.push(element.id);
        }
        postAccess('delink', delinkedId);

      }
    }
    prevLeft.current = left;
    prevRight.current = right;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [left, right]);

  return (
    <div>
      <Box mt={1}>
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Box >
            <Typography variant="h6" align="center">
              {`Unlinked ` + props.title}
            </Typography>
            <Grid item>{customList(left)}</Grid>
          </Box>
          <Grid item>
            <Grid container direction="column" alignItems="center">
              <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={() => { handleCheckedRight() }}
                disabled={leftChecked.length === 0}
                aria-label="move selected right"
              >
                &gt;
              </Button>
              <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={() => { handleCheckedLeft() }}
                disabled={rightChecked.length === 0}
                aria-label="move selected left"
              >
                &lt;
              </Button>
            </Grid>
          </Grid>
          <Box >
            <Typography variant="h6" align="center">
              {`Linked ` + props.title}
            </Typography>
            <Grid item>{customList(right)}</Grid>
          </Box>
        </Grid>
      </Box>
    </div>
  );
}

// export default withSnackbar(ProjectAccessList);
export default ProjectAccessList;
